<script setup lang="ts">
import type { DataTableCellProps } from './templateTypes';

/***
 * template to show process name badge
 */

const _props = defineProps<DataTableCellProps>();
</script>

<template>
  <Tag :value="row.processName" class="process-badge" severity="info">
    <span class="badgeIcon pi pi-microchip"></span>
    {{ row.processName }}
  </Tag>
</template>
